module.exports = __webpack_public_path__ + "img/chara_2.d0206130.png";